import React, { Component } from "react"
import { consumerBasicInfo, verifyUsername, getPasswordCreteria } from "../../BackendServices/registrationAPI"
import { withTranslation } from "react-i18next"
import Title from "../common/Title"
import TextInput from "../common/TextInput"
import AddLine from "./AddLine";
import ReCAPTCHA from "react-google-recaptcha"
import PasswordStrengthBar from 'react-password-strength-bar';
import ErrorAlert from "../common/ErrorAlert"
import { encrypt } from "../../BackendServices/generic"
import BackArrow from '../../assets/back-arrow.svg';

const win = window;

class ConsumerRegistration extends Component {

    constructor(props) {
        super(props)
        this.state = {
            userName: '',
            password: '',
            confirmPassword: '',
            email: '',
            errors: { userName: '', password: '', confirmPassword: '', email: '', recaptcha: '' },
            isSuccess: false,
            genericError: null,
            loading: false,
            toolTipMessage: "",
            passRegExpression: "",
            emailRegex: "",
            errorType: { userNameClassName: "", passwordClassName: "", confirmPasswordClassName: "", emailClassName: "", recaptchaClassName: "" },
        }
    }

    async componentDidMount() {
        let result = await getPasswordCreteria();
        const result1 = JSON.parse(result);
        const userPasswordRules = result1.data.user_password_rules_info;
        //const descriptionArray = userPasswordRules.tool_tip_info.description;
        const tooltipText = [...userPasswordRules.tool_tip_info.criteria_info]
        .sort((a, b) => Number(a.priority) - Number(b.priority))
        .map(item => window.lang === "ar" ? item.ar : item.en) .join("<br /><br />");


        await this.setState({
                toolTipMessage: tooltipText,
                passRegExpression: userPasswordRules.reg_expression,
                emailRegex: result1.data.email_reg_rules_info.reg_expression,
            });
       /*  if (window.lang === "en") {
            

           descriptionArray.length > 0 && descriptionArray.forEach((item) => {
                let arrayText = item.en === '' ? `${item.en}` : item.en + "<br /><br />";
                tooltipText += arrayText;
            });

            criteriaArray.length > 0 && criteriaArray.forEach(item => {
                let arrayText = item.en + "<br /><br />"
                tooltipText += arrayText
            });
            


            const toolTipMessage_en = tooltipText;
            await this.setState({
                toolTipMessage: toolTipMessage_en,
                passRegExpression: userPasswordRules.reg_expression,
                emailRegex: result1.data.email_reg_rules_info.reg_expression,
            });
        } else if (window.lang === "ar") {
         let tooltipText = '';

            descriptionArray.length > 0 && descriptionArray.forEach((item) => {
                let arrayText = item.ar === '' ? `${item.ar}` : item.ar + "<br /><br />";
                tooltipText += arrayText;
            });

            criteriaArray.length > 0 && criteriaArray.forEach(item => {
                let arrayText = item.ar + "<br /><br />"
                tooltipText += arrayText
            });

            const toolTipMessage_ar = tooltipText;
            await this.setState({
                toolTipMessage: toolTipMessage_ar,
                passRegExpression: userPasswordRules.reg_expression,
                emailRegex: result1.data.email_reg_rules_info.reg_expression,
            });
        }*/
    }

    handleValidation(formData) {
        let errors = {};
        let errorType = {};
        let formIsValid = false;

        for (var [key, value] of formData) {
            if (key !== 'g-recaptcha-response') {
                if (value === '') {
                    let errKey = `${key}ClassName`;
                    errors[key] = "required";
                    errorType[errKey] = "validation-error";
                }
            }

            // USERNAME
            if (key === 'userName') {
                if (typeof value !== "undefined" && value !== "") {
                    if (this.state.errors.userName !== '') {
                        let errKey = `${key}ClassName`;
                        errors[key] = this.state.errors.userName;
                        errorType[errKey] = "validation-error";
                    }
                }
            }

            // PASSWORD
            if (key === 'password') {
                let passwordRegex = new RegExp(this.state.passRegExpression);

                if (value !== "") {
                    if (!value.match(passwordRegex)) {
                        let errKey = `${key}ClassName`;
                        errors[key] = "password_match_pattern";
                        errorType[errKey] = "";
                    }
                }
            }

            // CONFIRM PASSWORD
            if (key === 'confirmPassword') {
                if (typeof value !== "undefined" && value !== "") {
                    if (this.state.errors.confirmPassword !== '') {
                        let errKey = `${key}ClassName`;
                        errors[key] = this.state.errors.confirmPassword;
                        errorType[errKey] = "";
                    }
                }
            }

            //EMAIL
            if (key === 'email') {
                if (typeof value !== "undefined" && value !== "") {
                    let lastAtPos = value.lastIndexOf('@');
                    let lastDotPos = value.lastIndexOf('.');

                    if (!(lastAtPos < lastDotPos && lastAtPos > 0 && value.indexOf('@@') === -1 && lastDotPos > 2 && (value.length - lastDotPos) > 2)) {
                        let errKey = `${key}ClassName`;
                        errors[key] = "invalid_email";
                        errorType[errKey] = "validation-error";
                    }
                }
            }

            if (key === 'g-recaptcha-response') {
                if (!value) {
                    errors['recaptcha'] = "required";
                }
            }

        }

        if (JSON.stringify(errors) === '{}') {
            formIsValid = true;
        }

        this.setState({
            errors: errors,
            errorType: errorType
        });
        return formIsValid;
    }

    handaleSubmit = async (e) => {
        const formData = new FormData(e.target);
        let formIsValid = false;
        formIsValid = this.handleValidation(formData.entries())
        e.preventDefault();
        if (formIsValid) {
            await this.consumerBasicInfo();
        }
    }

    consumerBasicInfo = async () => {
        let requestBody = {
            "userBasicInfo": {
                "userName": encrypt(this.state.userName),
                "password": encrypt(this.state.password),
                "email": this.state.email
            },
            "lineRegisterIsMust": this.props.isThirdParty ? true : false,
            "clientInfo": {
                "clientId": this.props.clientId,
                ...(this.props.clientId !== window.OAUTHUserName && { "redirectUrl": this.props.redirectURL })
            }
        }

        await this.setState({
            loading: true
        })

        try {
            let result = await consumerBasicInfo(requestBody)
            // Signup Completed Event
            win.MixpanelTracker.trackEvent("Signup Completed");
            await this.setState({
                transactionId: result.transactionId,
                isSuccess: true,
                genericError: null,
                loading: false
            })
        } catch (error) {
            if(error.message === `Email Already Existed`) {
                win.MixpanelTracker.trackEvent("Signup Form Failed", {
                    fail_reason : 'existing_email_id'
                });
            }
            this.setState({
                genericError: error.message,
                loading: false,
            })
        }
    }

    handleConfirmPassword = (e) => {
        if (e.target.value !== this.state.password) {
            this.state.errors.confirmPassword = 'password_not_match'
            this.state.errorType.confirmPasswordClassName = 'validation-error'
            this.setState({
                [e.target.name]: e.target.value,
            })
        } else {
            this.state.errors.confirmPassword = ''
            this.state.errorType.confirmPasswordClassName = ''
            this.setState({
                [e.target.name]: e.target.value,
            })
        }
    }

    handleChange = async e => {
        e.persist();
        await this.setState({
            [e.target.name]: e.target.value,
        })

        if (this.state.confirmPassword !== '' && this.state.confirmPassword !== this.state.password) {
            this.state.errors.confirmPassword = 'password_not_match'
            this.state.errorType.confirmPasswordClassName = 'validation-error'
            this.setState({
                [this.state.errors.confirmPassword]: 'password_not_match',
                [this.state.errorType.confirmPasswordClassName]: 'validation-error'
            })
        } else {
            this.state.errors.confirmPassword = ''
            this.state.errorType.confirmPasswordClassName = ''
            this.setState({
                [this.state.errors.confirmPassword]: '',
                [this.state.errorType.confirmPasswordClassName]: ''
            })
        }

        // PASSWORD
        if (e.target.name === 'password') {
            if (typeof e.target.value !== "undefined") {
                let passwordRegex = new RegExp(this.state.passRegExpression);
                if (e.target.value !== '' && !e.target.value.match(passwordRegex)) {
                    this.state.errors.password = 'password_match_pattern'
                    this.state.errorType.passwordClassName = "validation-error";
                    this.setState({
                        [this.state.errors.password]: 'password_match_pattern',
                        [this.state.errorType.passwordClassName]: 'validation-error',
                    })
                } else {
                    this.state.errors.password = ''
                    this.state.errorType.passwordClassName = "";
                    this.setState({
                        [this.state.errors.password]: '',
                        [this.state.errorType.passwordClassName]: '',
                    })
                }
            }
        }
        if (e.target.name === 'email') {
            console.log("email pattern: " + this.state.emailRegex);
            if (typeof e.target.value !== "undefined") {
                let emailRegex = new RegExp(this.state.emailRegex);
                if (e.target.value !== '' && !e.target.value.match(emailRegex)) {
                    this.state.errors.email = 'email_match_pattern';
                    this.state.errorType.emailClassName = "validation-error";
                    this.setState({
                        [this.state.errors.email]: 'email_match_pattern',
                        [this.state.errorType.emailClassName]: "validation-error"
                    })
                } else {
                    this.state.errors.email = '';
                    this.state.errorType.emailClassName = "";
                    this.setState({
                        [this.state.errors.email]: '',
                        [this.state.errorType.emailClassName]: ""
                    })
                }
            }
        }
    }

    verifyUsername = async e => {
        if ((e.target.value).match(/[\u0600-\u06FF\u0750-\u077F]/)) {
            this.state.errors.userName = 'arabic_not_allowed'
            this.state.errorType.userNameClassName = "api-error"

            this.setState({
                [this.state.errors.userName]: 'arabic_not_allowed',
                [this.state.errorType.userNameClassName]: "api-error"
            })
        } else {
            let requestBody = {
                "username": e.target.value
            }

            try {
                await this.setState({
                    loading: true
                })
                let result = await verifyUsername(requestBody)
                //console.log("res => "+JSON.stringify(result))

                this.state.errors.userName = ''
                this.state.errorType.userNameClassName = "api-error"

                this.setState({
                    [this.state.errors.userName]: '',
                    [this.state.errorType.userNameClassName]: "",
                    genericError: null,
                    loading: false
                })
            } catch (error) {
                this.state.errors.userName = error.message
                this.state.errorType.userNameClassName = "api-error"
                if(error.message === `You couldn't use this information for registration, please try again`) {
                        win.MixpanelTracker.trackEvent("Signup Form Failed", {
                        fail_reason : 'existing_user_id'
                    });
                }

                this.setState({
                    [this.state.errors.userName]: error.message,
                    [this.state.errorType.userNameClassName]: "api-error",
                    loading: false
                })
            }
            if (this.state.password !== "undefined" && this.state.userName !== '') {
                let passwordRegex = new RegExp(this.state.passRegExpression);
                if (this.state.password !== '' && !this.state.password.match(passwordRegex)) {
                    this.state.errors.password = 'password_match_pattern'
                    this.state.errorType.passwordClassName = "validation-error";
                    this.setState({
                        [this.state.errors.password]: 'password_match_pattern',
                        [this.state.errorType.passwordClassName]: "validation-error"
                    })
                } else {
                    this.state.errors.password = '';
                    this.state.errorType.passwordClassName = "";
                    this.setState({
                        [this.state.errors.password]: '',
                        [this.state.errorType.passwordClassName]: ""
                    })
                }
            }
        }
    }

    render() {
        const { t } = this.props;

        return (
            <>
                {this.state.loading && <div className="loading">Loading&#8230;</div>}
                {!this.state.isSuccess &&
                    <section>
                        <div className="loginIntroTextContainer">
                            <a className="registrationBackButton" href="javascript:history.back()">
                                <img src={BackArrow} alt='back' />
                            </a>
                            <Title title={t('create_new_account')} />

                        </div>
                        <div className="tabs">
                            <div className="tab-content">
                                {this.state.genericError && (
                                    <>
                                        <ErrorAlert error={this.state.genericError} />
                                        <div style={{ display: "none" }} className={this.state.genericError ? "api-error" : ""}>{this.state.genericError}</div>
                                    </>
                                )}
                                <form onSubmit={this.handaleSubmit} id={'personal-registration-form'}>
                                    {/* EMAIL FIELD */}
                                    <TextInput id={"email"} label={"email"} name={"email"} value={this.state.email} type={"text"} error={this.state.errors.email} errorType={this.state.errorType.emailClassName} handleChange={this.handleChange} />

                                    {/* USERNAME FIELD */}
                                    <TextInput id={"username"} label={"username"} name={"userName"} value={this.state.userName} type={"text"} error={this.state.errors.userName} errorType={this.state.errorType.userNameClassName} handleChange={this.handleChange} handleBlur={this.verifyUsername} />

                                    {/* PASSWORD FIELD */}
                                    <TextInput id={"password"} label={"password"} name={"password"} value={this.state.password} type={"password"} error={this.state.errors.password} errorType={this.state.errorType.passwordClassName} handleChange={this.handleChange} tooltip={this.state.toolTipMessage} />
                                    <PasswordStrengthBar scoreWords={[t('weak'), t('weak'), t('okay'), t('good'), t('strong')]} shortScoreWord={t('too_short')} minLength={12} scoreWordStyle={{ color: 'white' }} password={this.state.password} />

                                    {/* CONFIRM PASSWORD FIELD */}
                                    <TextInput id={"confirmPassword"} label={"confirm_password"} name={"confirmPassword"} value={this.state.confirmPassword} type={"password"} error={this.state.errors.confirmPassword} errorType={this.state.errorType.confirmPasswordClassName} handleChange={this.handleConfirmPassword} />

                                    {/* ReCAPTCHA PART */}
                                    <ReCAPTCHA ref={this.recaptchaRef}
                                        className="mt-4"
                                        sitekey={window.INVISIBLE_CAPTCHA_V2_SITE_KEY}
                                        type="image"
                                        hl={window.lang === 'ar' ? "ar" : "en"}
                                        name={"recaptcha"}
                                    />
                                    {this.state.errors.recaptcha &&
                                        <ErrorAlert error={this.state.errors.recaptcha} />
                                    }

                                    <button type="submit" id={"registration-submitButton"} className="btn min_outlin_btn active formEle-Button">
                                        {t("sign_up")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                    {/* <div className="termsText">{`${t('mobily_registry')} ${t('term_condition')} ${t('and')} ${t('privacy_policy')}`}</div> */}
                                    {
                                        <div className="termsText">
                                            {t('mobily_registry')}
                                            <a href={window.TERMS_CONDITIONS_LINK}>
                                                <u className="termsCondition">{t("term_condition")}</u>
                                            </a>
                                            {t('and')}
                                            <a href={window.PRIVACY_BAR_LINK}>
                                                <u className="privcyPolicy">{t("privacy_policy")}</u>
                                            </a>
                                        </div>
                                    }
                                </form>
                            </div>
                        </div>
                    </section>}
                {this.state.isSuccess && <AddLine userName={this.state.userName} userEmail={this.state.email} redirectURL={this.props.redirectURL} transactionId={this.state.transactionId} clientId={this.props.clientId} clientInfo={this.props.clientInfo} isThirdParty={this.props.isThirdParty} />}
            </>
        )
    }
}
export default withTranslation()(ConsumerRegistration);